/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetChallengeEntitlementResponseDto
 */
export interface GetChallengeEntitlementResponseDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'deletedAt': string;
    /**
     * Challenge category ID this entitlement belongs to
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'challengeCategoryId': string;
    /**
     * Name of the entitlement
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'name': string;
    /**
     * Description of the entitlement
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'description'?: string;
    /**
     * Whether this entitlement is required (automatically added) or optional
     * @type {boolean}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'isOptional': boolean;
    /**
     * Price amount for this entitlement
     * @type {number}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'priceAmount': number;
    /**
     * Remaining quantity available for this entitlement (0 = discontinued)
     * @type {number}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'remainingQuantity': number;
    /**
     * Used quantity of this entitlement (sold/reserved)
     * @type {number}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'usedQuantity': number;
    /**
     * Whether this entitlement has unlimited quantity available
     * @type {boolean}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'isUnlimited': boolean;
    /**
     * Array of image URLs for this entitlement
     * @type {Array<string>}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Display order for sorting entitlements in UI
     * @type {number}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'displayOrder': number;
    /**
     * Type of entitlement
     * @type {string}
     * @memberof GetChallengeEntitlementResponseDto
     */
    'type': GetChallengeEntitlementResponseDtoTypeEnum;
}

export const GetChallengeEntitlementResponseDtoTypeEnum = {
    Physical: 'physical',
    Digital: 'digital'
} as const;

export type GetChallengeEntitlementResponseDtoTypeEnum = typeof GetChallengeEntitlementResponseDtoTypeEnum[keyof typeof GetChallengeEntitlementResponseDtoTypeEnum];


